import { connect } from 'react-redux';
import ModalConfirmForm from './ModalConfirmForm';
import { performSingleAction } from '../../../redux/actions';

const mapDispatchToProps = {
  onSubmit: performSingleAction,
};

export default connect(null, mapDispatchToProps)(ModalConfirmForm);




// WEBPACK FOOTER //
// ./src/js/common/components/ModalConfirmForm/SingleActionConfirmForm.js